import { useEffect, useMemo, useState } from 'react'
import { ThemeProvider } from 'styled-components'
import { useMainContext } from '../../core/contexts/main'
import { useWindowSize } from '../../core/hooks/useWindowSize'
import Sidebar from './Sidebar'
import { MainBody, Flex, MainWrapper, RespWrapper } from '../../styles/layout-styles/CommonStyles'
import MasterHeader from './MasterHeader'
import { CLOSE_SIDEBAR_SIZE, LAPTOP_SIZE, MOBILE_SIZE, TABLET_SIZE } from '../../core/constants/common'
import { Link, useLocation } from 'react-router-dom'
import { getMainTheme } from '../../core/utils/theme'
import BottomBar from './BottomBar'
import Toast from '../modals/Toast'
import { AuthContextProvider } from "../../core/contexts/auth";
import LogoutLoading from "./loading/LogoutLoading";
import { Text } from '../../modules/Dashboard'

const PATHNAMES = [
	{ pathname: '/dashboard', title: "home" },
	{ pathname: '/wallet', title: "wallet" },
	{ pathname: '/assistant', title: "assistants" },
	{ pathname: '/wallet/deposit-coin', title: "deposit-coin" },
	{ pathname: '/transactions', title: "history" },
	{ pathname: '/transactions/deposit', title: "deposit-transactions-history" },
	{ pathname: '/transactions/nexa', title: "nexa-transactions-history" },
	{ pathname: 'swap', title: "Swap" },
	{ pathname: '/wallet/swap', title: "Swap" },
	{ pathname: '/plans', title: "plans" },
	{ pathname: '/invite-friends', title: "invite-friends" },
	{ pathname: '/notifications', title: "notifications" },
]

const MainLayout = ({ children, hasSidebar = true } = {}) => {
	const location = useLocation()
	const { width } = useWindowSize()
	const [pageTitle, setPageTitle] = useState('home')

	const {
		main: { theme, lang },
		profile: { token },
	} = useMainContext()

	const themeObject = useMemo(() => getMainTheme(theme, lang), [theme, lang])

	useEffect(() => {
		if (location.pathname) {
			let currentTitle = PATHNAMES.find(p => location.pathname.includes(p.pathname))
			setPageTitle(currentTitle?.title || "")
		}

	}, [location])

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [location])

	useEffect(() => {
		if (lang === 'fa') {
			document.documentElement.setAttribute('dir', 'rtl')
			document.documentElement.setAttribute('lang', 'fa')
		} else {
			document.documentElement.setAttribute('dir', 'ltr')
			document.documentElement.setAttribute('lang', 'en')
		}
	}, [lang])


	return (
		<ThemeProvider theme={themeObject}>
			<AuthContextProvider>
				<MainBody isAuthed={!!token}
				>
					<div className={`bg-gradient-to-br from-[#00C950] to-[#007A55] w-screen h-[45px] fixed top-0 left-0 z-[999]`}>
						<div className='flex justify-center items-center gap-2 sm:gap-5 w-full h-full'>
							<img src={require("../../assets/images/trading-pro/globe-banner-img.png")} width={60} height={35} alt='' className='hidden md:block' />
							<Text tid="plan-off-banner" className='	lg:text-xl rtl:text-sm md:rtl:text-base' />
							<Link to={"/plans"} className='px-3 p-1 bg-gradient-to-r from-[#FC6432] to-[#A855F7] rounded-lg'>
								<Text tid={"view-plans"} className='text-xs xs:text-sm md:text-base' />
							</Link>
						</div>
					</div>
					{
						token &&
						<MasterHeader pageTitle={pageTitle} />
					}
					<Flex className={`relative transition-all delay-100 ease-in-out ${width >= LAPTOP_SIZE && token ? false ? 'mt-[140px]' : 'mt-[120px]' : 'mt-[65px]'}`}>
						{hasSidebar && (
							<Sidebar />
						)}
						{width <= CLOSE_SIDEBAR_SIZE ? (
							<RespWrapper>{children}</RespWrapper>
						) : (
							<>
								{hasSidebar ? (
									<MainWrapper>{children}</MainWrapper>
								) : (
									<RespWrapper>{children}</RespWrapper>
								)}
							</>
						)}
					</Flex>
				</MainBody>

				{(token && width <= LAPTOP_SIZE) && <BottomBar />}
				<Toast />
				<LogoutLoading />
			</AuthContextProvider>
		</ThemeProvider>
	)
}

export default MainLayout
